export default "__VITE_ASSET__CBFnywIP__"